module.exports = __webpack_public_path__ + "img/slide-27.68d7b001.jpeg";